import { PROVIDE_CLIENT_INTAKE_RESPONSES_STATE } from '@db-access/clientIntakeResponses';

export const PROVIDE_INTAKE_FORM_CLIENT_RESPONSES_STATE = [
	...PROVIDE_CLIENT_INTAKE_RESPONSES_STATE,
];
